module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/LIBERAL ARTS-591135d2606033610f8478794a8f1ed9.png";